import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'AGGIUNGI ESERCIZI',
        description: 'Premi qui per cercare e aggiungere nuovi esercizi alla tua verifica.',
        name: 'AddExercisesCard',
        tutorialName: 'dettaglio-verifica-docente_aggiungi-esercizio'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'left',
        xPlacement: 'RIGHT',
        yPlacement: 'TOP',
        xOffset: 0,
        yOffset: 25
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'CENTER',
        yPlacement: 'TOP',
        xOffset: 0,
        yOffset: 5
    }
};
